import { z } from 'zod';

export type DataPoint = {
  x: number;
  y: number | null;
};

export type Dataset = {
  label: string;
  data: DataPoint[];
  symbols: {
    x: string;
    y: string;
  };
};

export const displayModes = ['chart', 'table', 'settings'] as const;
export type DisplayMode = (typeof displayModes)[number];

export enum ChartScale {
  Linear = 'linear',
  Logarithmic = 'logarithmic',
}

export type ChartStreams = Record<string, boolean>;

const ChartStreamStyleSchema = z.object({
  borderColor: z.string().optional(),
  borderWidth: z.number().optional(),
  borderStyle: z.enum(['solid', 'dashed', 'dotted']).optional(),
});
export const ChartStreamStylesSchema = z.record(
  z.string(),
  ChartStreamStyleSchema
);

export type ChartStreamStyle = z.infer<typeof ChartStreamStyleSchema>;
export type ChartStreamStyles = z.infer<typeof ChartStreamStylesSchema>;
